import { z } from "zod";

export const getSubordersQuerySchema = z.object({
	warehouseZoneId: z.uuid().optional(),
	/**
	 * `all` (the default) returns every round the picker may work. `zoneless` returns only the
	 * rounds that carry no warehouse zone — an order of Leergut and no articles derives one of
	 * those, and it needs a filter of its own because an absent `warehouseZoneId` already means
	 * "every zone" rather than "no zone".
	 */
	scope: z.enum(["all", "zoneless"]).optional(),
});

export type GetSubordersQuerySchema = z.infer<typeof getSubordersQuerySchema>;
